(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["tth-collective-gallery"] && !Shopify.designMode) return;
  try {
    function initializePartnerGalleries(root) {
    root.querySelectorAll('[data-partner-gallery]').forEach(function(gallery) {
      if(gallery.dataset.galleryReady) return;
      const track=gallery.querySelector('.tth-partner-gallery__track');
      const thumbnails=gallery.querySelector('.tth-partner-gallery__thumbnails');
      const slides=Array.from(track.children);
      const thumbnailControls=Array.from(gallery.querySelectorAll('[data-partner-gallery-index]'));
      if(!slides.length) return;
      function start() {
        if(gallery.dataset.galleryReady || !gallery.isConnected) return;
        gallery.dataset.galleryReady='true';
        gallery.querySelectorAll('img').forEach(function(image){image.draggable=false;});
        const main=new window.Flickity(track,{
          cellSelector:'.tth-partner-gallery__slide',cellAlign:'left',contain:true,
          imagesLoaded:false,lazyLoad:3,wrapAround:false,pageDots:slides.length>1,
          prevNextButtons:false,draggable:slides.length>1,
          selectedAttraction:0.018,friction:0.22,dragThreshold:6,adaptiveHeight:false
        });
        const nav=thumbnails ? new window.Flickity(thumbnails,{
          cellSelector:'.tth-partner-gallery__thumbnail',asNavFor:track,
          cellAlign:'left',contain:true,imagesLoaded:false,lazyLoad:3,
          pageDots:false,prevNextButtons:false
        }) : null;
        const dots=Array.from(track.querySelectorAll('.flickity-page-dots .dot'));
        dots.forEach(function(dot,index){
          dot.setAttribute('role','button');
          dot.tabIndex=0;
          dot.setAttribute('aria-label',gallery.dataset.mediaLabel.replace('[number]',String(index+1)));
        });
        function select(index) {
          main.select(index,false,window.matchMedia('(prefers-reduced-motion: reduce)').matches);
        }
        function synchronize() {
          const selected=main.selectedIndex;
          thumbnailControls.forEach(function(control,index) {
            const active=index===selected;
            control.classList.toggle('is-nav-selected',active);
            control.setAttribute('aria-pressed',String(active));
          });
          dots.forEach(function(dot,index){dot.setAttribute('aria-pressed',String(index===selected));});
        }
        main.on('select',synchronize);
        function keyboardControls(event) {
          const dot=event.target.closest('.flickity-page-dots .dot');
          if(dot && track.contains(dot) && (event.key==='Enter' || event.key===' ')) {
            event.preventDefault();
            event.stopPropagation();
            select(dots.indexOf(dot));
          }
          if(event.target!==track) return;
          if(event.key==='Home'){event.preventDefault();select(0);}
          if(event.key==='End'){event.preventDefault();select(slides.length-1);}
        }
        track.addEventListener('keydown',keyboardControls);
        function keyboardThumbnailClick(event) {
          const control=event.target.closest('[data-partner-gallery-index]');
          if(control && gallery.contains(control) && event.detail===0) select(Number(control.dataset.partnerGalleryIndex));
        }
        gallery.addEventListener('click',keyboardThumbnailClick);
        function selectVariantMedia(event) {
          const detail=event.detail || {};
          const section=gallery.closest('.shopify-section');
          if(section && section.id !== 'shopify-section-'+detail.sectionId) return;
          const media=detail.variant && detail.variant.featured_media;
          if(!media) return;
          const index=slides.findIndex(function(slide){return slide.dataset.mediaId===String(media.id);});
          if(index>=0) select(index);
        }
        document.addEventListener('variant:change',selectVariantMedia);
        const initialIndex=slides.findIndex(function(slide){return slide.dataset.mediaId===gallery.dataset.initialMediaId;});
        if(initialIndex>=0) main.select(initialIndex,false,true);
        synchronize();
        const resize=function(){main.resize();if(nav) nav.resize();};
        window.addEventListener('load',resize,{once:true});
        requestAnimationFrame(function(){requestAnimationFrame(resize);});
        function destroy(event) {
          if(!event.target.contains(gallery)) return;
          document.removeEventListener('variant:change',selectVariantMedia);
          document.removeEventListener('shopify:section:unload',destroy);
          window.removeEventListener('load',resize);
          track.removeEventListener('keydown',keyboardControls);
          gallery.removeEventListener('click',keyboardThumbnailClick);
          if(nav) nav.destroy();
          main.destroy();
          delete gallery.dataset.galleryReady;
        }
        document.addEventListener('shopify:section:unload',destroy);
      }
      if(typeof window.Flickity==='function'){start();return;}
      if(!window.tthCollectiveFlickityLoad) {
        window.tthCollectiveFlickityLoad=new Promise(function(resolve,reject) {
          const source=gallery.dataset.flickitySrc;
          let script=Array.from(document.scripts).find(function(item){return item.src===source;});
          if(!script){script=document.createElement('script');script.src=source;script.defer=true;document.head.appendChild(script);}
          script.addEventListener('load',resolve,{once:true});
          script.addEventListener('error',reject,{once:true});
        });
      }
      window.tthCollectiveFlickityLoad.then(start).catch(function(){window.tthCollectiveFlickityLoad=null;});
    });
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',function(){initializePartnerGalleries(document);},{once:true});
  else initializePartnerGalleries(document);
  document.addEventListener('shopify:section:load',function(event){initializePartnerGalleries(event.target);});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tth-product-essentials"] && !Shopify.designMode) return;
  try {
    document.addEventListener('toggle', function(event) {
    const detail=event.target;
    if(detail.tagName!=='DETAILS'||!detail.open) return;
    const group=detail.closest('.tth-inline-details');
    if(group) group.querySelectorAll('details[open]').forEach(other=>{if(other!==detail)other.open=false;});
  },true);
  document.addEventListener('click',function(event){
    const opener=event.target.closest('[data-tth-details-open]');
    if(!opener)return;
    const root=opener.closest('.product__info-container');
    const group=root?.querySelector('.tth-inline-details');
    if(!group)return;
    event.preventDefault();event.stopImmediatePropagation();
    const disclosure=group.closest('.tth-item-more');
    if(disclosure)disclosure.open=true;
    const rows=group.querySelectorAll('details');
    const row=opener.hasAttribute('data-tth-open-shipping')?rows[rows.length-1]:rows[0];
    rows.forEach(other=>{other.open=other===row;});
    row.querySelector('summary').focus();row.scrollIntoView({block:'nearest'});
  },true);
  } catch(e) { console.error(e); }
})();

})();
